import moment from 'moment';
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable.jsx';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header.jsx';

//Date Math Grid Columns and Helpers
export const statusIndicator = {
    headerName: '',
    field: 'spaJobStatus',
    width: 16,
    cellRenderer: params => (
        <div style={{ position: 'relative', width: '100%', height: '100%', background: '#fff' }}>
            <div
                style={{
                    position: 'absolute',
                    left: 2,
                    top: 0,
                    bottom: 0,
                    width: '4px',
                    background: getColorForStatus(params.value),
                    borderRadius: '2px',
                }}
            />
            <span
                style={{
                    marginLeft: '4px',
                    background: getColorForStatus(params.value),
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                }}
            >&nbsp;</span>
        </div>
    ),
    cellStyle: { padding: 0 },
    suppressMenu: true,
    sortable: false,
    filter: false,
};
export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'dateMath',
    },
    minWidth: 100,
};

export const spaJobStatus = {
    field: 'spaJobStatus',
    headerName: 'Job Status',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'spaJobStatus',
        page: 'dateMath',
    },
    minWidth: 100,
};

export const spaJobType = {
    field: 'spaJobType',
    headerName: 'Job Type',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'spaJobType',
        page: 'dateMath',
    },
    minWidth: 400,
};

export const targetCount = (
    onOpenDateMathCalculations,
) => ({
    field: 'targetCount',
    headerName: 'Date Match Calculations',
    cellRenderer: ClickableCellRenderer(onOpenDateMathCalculations, ''),
    minWidth: 200,
});

export const progressCount = {
    field: 'progressCount',
    headerName: 'Progress',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'errorCount',
        page: 'dateMath',
    },
    minWidth: 100,
};

export const errorCount = {
    field: 'errorCount',
    headerName: 'Errors',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'errorCount',
        page: 'dateMath',
    },
    minWidth: 100,
};

export const startedByUser = {
    field: 'startedByUser',
    headerName: 'Started By',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'startedByUser',
        page: 'dateMath',
    },
    minWidth: 200,
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).format('MM/DD/YYYY, h:mm:ss A') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'dateMath',
    },
    minWidth: 200,
};

export const completedAt = {
    field: 'completedAt',
    headerName: 'Completed',
    valueFormatter: ({ value }) => (value ? moment(value).format('MM/DD/YYYY, h:mm:ss A') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'completedAt',
        page: 'dateMath',
    },
    minWidth: 200,
};

export const actions = (
    startJobAction,
    deleteJobAction,
) => ({
    headerName: 'Actions',
    field: 'spaJobStatus',
    valueGetter: (params) => getActionForStatus(params?.data),
    cellRenderer: (params) => {
        const value = getActionForStatus(params?.data);
        let actionHandler;
        if (value === 'START JOB') actionHandler = startJobAction;
        else if (value === 'DELETE JOB') actionHandler = deleteJobAction;
        else actionHandler = () => {};

        const Renderer = ClickableCellRenderer(actionHandler, '');
        return <Renderer value={value} data={params?.data} />;
    },
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'spaJobStatus',
        page: 'dateMath',
    },
    minWidth: 200,
});


// Helper function for color mapping
function getColorForStatus(status) {
    const s = (status || '').toUpperCase();
    if (['COMPLETE', 'STARTING', 'READY', 'CREATED', 'VALIDATING', 'RUNNING'].includes(s)) {
        return '#4caf50';
    }
    if (['FAILED', 'INVALID', 'ABORTED', 'ERROR'].includes(s)) {
        return '#f44336';
    }
    return '#ccc';
}

function getActionForStatus(record) {
    const email = localStorage.getItem('email');
    const userMatch =
        record.startedByUser &&
        email &&
        record.startedByUser.toLowerCase().trim() === email.toLowerCase().trim();

    const isInvalidOrFailedNotComplete =
        ((record.spaJobStatus === 'INVALID' && record.spaJobStatus !== 'COMPLETE') ||
            (record.spaJobStatus === 'FAILED' && record.spaJobStatus !== 'COMPLETE'));

    if ((isInvalidOrFailedNotComplete || record.targetCount === 0) && userMatch) {
        return 'DELETE JOB';
    }

    const isReadyOrFailedWithTarget =
        (record.spaJobStatus === 'READY' || record.spaJobStatus === 'FAILED') &&
        record.targetCount > 0 &&
        userMatch;

    if (isReadyOrFailedWithTarget) {
        return 'START JOB';
    }

    return '';
}
